import { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { SubmitHandler, useForm } from 'react-hook-form';
import { Link } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import { B2BAuthContext } from '../../../Context/AuthContex/B2BAuthContext';
import Toaster from '../../../Components/Toaster/Toaster';
import fetcher from '../../../Helpers/Fetcher/fetchApi';
import { B2B_USER_FAILED, B2B_USER_SUCCESS } from '../../../Helpers/Constant';
import Layout from '../../../Components/Layout/Layout';
import InputField from '../../../Components/Common/InputField';
import Loader from '../../../Components/Spinner/Loader';

interface inputForm {
  email: string;
  password: string;
}
const B2BLogin = () => {
  const [searchParams] = useSearchParams();
  const b2b_type = searchParams.get('type');
  const { dispatch: authDispatch, isLoading, setIsLoading } = B2BAuthContext();
  const Toast = Toaster();
  const navigate = useNavigate();
  const { register, handleSubmit } = useForm<inputForm>();
  const [passwordType, setPasswordType] = useState('password');

  const onSubmit: SubmitHandler<inputForm> = async (data) => {
    try {
      setIsLoading?.(true);
      const res = await fetcher.post({
        url: '/api/auth/b2b/login',
        contentType: 'application/json',
        body: data,
      });

      if (res.success) {
        Toast.fire({
          icon: 'success',
          title: `successfully login`,
        });
        authDispatch?.({
          type: B2B_USER_SUCCESS,
          payload: { ...res.data, token: res.token },
        });
        localStorage.setItem('toab_fair', res.token);
        setIsLoading?.(false);
        navigate('/b2b/profile');
      } else {
        Toast.fire({
          icon: 'error',
          title: res.message,
        });
        setIsLoading?.(false);
        authDispatch?.({ type: B2B_USER_FAILED });
      }
    } catch (error) {
      authDispatch?.({ type: B2B_USER_FAILED });
    }
  };
  return (
    <Layout>
      <div className='login-wrapper'>
        <div className='login-div'>
          <div className='visitor-login-page'>
            <div className='text-center'>
              <p className='fw-bold fs-3'>Login</p>
              <p className='fw-bold fs-3'>
                {b2b_type === 'Both' ? 'Buyer/Seller' : b2b_type} B2B Meeting
              </p>
            </div>

            <div className='login-form'>
              <form onSubmit={handleSubmit(onSubmit)}>
                <div>
                  <InputField
                    label='Enter your email'
                    register={register('email')}
                    type='text'
                    isRequired
                    placeholder='Enter your email address'
                  />
                </div>
                <div className='pt-3'>
                  <InputField
                    label='Enter your password'
                    register={register('password')}
                    type={passwordType}
                    isRequired
                    placeholder='Enter your password'
                  />
                </div>
                <div className=' pt-2 d-flex align-items-center justify-content-between'>
                  <div className='d-flex align-items-center'>
                    <input
                      type='checkbox'
                      onClick={() => {
                        passwordType === 'password'
                          ? setPasswordType('text')
                          : setPasswordType('password');
                      }}
                    />
                    <p className='ps-2'>Show password</p>
                  </div>
                  <Link
                    to='/forget-password?type=forget_b2b'
                    style={{ textDecoration: 'none' }}
                  >
                    <p className='text-primary'>Forgot password</p>
                  </Link>
                </div>

                <div>
                  {isLoading ? (
                    <Loader css={'w-100 mt-3 text-white'} />
                  ) : (
                    <Button
                      type='submit'
                      className='w-100 mt-3 submit-button common-btn'
                    >
                      Login
                    </Button>
                  )}
                </div>
                <div className='d-flex align-items-center my-4'>
                  <div className='flex-grow-1 border-top border-secondary'></div>
                  <span className='mx-2 py-2  text-black '>
                    <Link
                      to={
                        b2b_type === 'Buyer'
                          ? '/b2b-registration?type=Buyer'
                          : b2b_type === 'Both'
                          ? '/b2b-registration?type=Both'
                          : '/b2b-registration?type=Seller'
                      }
                      className='text-decoration-none'
                    >
                      {b2b_type === 'Both' ? 'Buyer/Seller' : b2b_type} B2B
                      register
                    </Link>
                  </span>
                  <div className='flex-grow-1 border-top border-secondary'></div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default B2BLogin;
